import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import styles from '../request-equipment-service.module.scss';
import { FIRST_AVAILABLE_IMG } from '../constant';
import { useTranslations } from 'next-intl';
import { Image } from 'components/image';

const RequestEquipmentServiceFirstAvailableWrapper = () => {
  const t = useTranslations();
  return (
    <div
      className={`mx-auto mb-3 ${styles['preferred-date-wrapper__first-available']}`}
    >
      <Image
        src={FIRST_AVAILABLE_IMG.src}
        alt={FIRST_AVAILABLE_IMG.alt}
        width={FIRST_AVAILABLE_IMG.width}
        height={FIRST_AVAILABLE_IMG.height}
      />
      <CatHeading variant="body-sm">
        <span
          className={`d-block ${styles['preferred-date-wrapper__first-available--thank-you']}`}
        >
          {t('THANK_YOU_1')}
        </span>
        <span
          className={
            styles['preferred-date-wrapper__first-available--description']
          }
        >
          {t('REQUEST_SERVICE_FIRST_AVAILABLE')}
        </span>
      </CatHeading>
    </div>
  );
};

export default RequestEquipmentServiceFirstAvailableWrapper;
